<template>
  <section
    class="pdf-content"
    style="margin: 20px; font-family: Red Hat Text, sans-serif;"
  >
    <h2>CAM Report - {{ date }}</h2>
    <section style="display: flex; justify-content:center; align-items:center;">
      <chart
        type="line-chart"
        :data="_roundsPlayed.data"
        :labels="_roundsPlayed.labels"
        id="total-rounds-played-chart"
        title="Total Rounds Played"
        :width="graphWidth('100%')"
      />
    </section>
    <section style="display:flex; flex-direction:column;">
      <div
        style="display: flex; justify-content:center; width:100%; margin-bottom:10px;"
      >
        <div style="display: flex; flex-direction: column; width:50%;">
          <h2 style="padding: 20px;">
            Dyanamic Yardages
          </h2>
          <chart
            type="gauge"
            :data="_dynamicYardageChart.data"
            :width="graphWidth('100%')"
            :labels="['Dynamic Yardage']"
          />
        </div>
        <div style="display: flex; flex-direction: column; width:50%;">
          <h2 style="padding: 20px;">
            Food and Beverage
          </h2>
          <chart
            type="gauge"
            :data="[_foodAndBeverageChart]"
            :labels="['Food and Beverage']"
            :width="graphWidth('100%')"
          />
        </div>
      </div>
      <div
        style="width: 100%; display:flex; justify-content: center; margin-top: -60px;"
      >
        <chart
          type="pie"
          :data="_scorecardChart"
          :labels="['ScoreCard Used', 'ScoreCard Not Used']"
          :width="graphWidth('100%')"
          title="Scorecard"
          height="300px"
        />
      </div>
    </section>
    <section style="display: flex; padding-top: 50px;">
      <v-card
        class="d-flex flex-column ma-3"
        style="overflow: hidden; width:100%;"
      >
        <v-card-title>Listen</v-card-title>
        <div
          style="width: 100%; min-height: 100%; display:flex; padding-left:10px;"
        >
          <div
            class="d-flex flex-column"
            style="width: 15%; max-width: 15%; height: 100%; margin-top:60px;"
          >
            <img
              src="../../assets/tuneinlogo.png"
              style="max-width: 85px; max-height: 85px"
            />
            <img
              src="../../assets/bluetooth.png"
              style="max-width: 85px; max-height: 85px"
            />
            <img
              src="../../assets/audacy_logo_stacked.png"
              style="max-width: 85px; max-height: 85px"
            />
          </div>
          <div style="min-width: 90%">
            <chart
              type="bar-chart"
              :flat="true"
              :data="_listenChart.data"
              :labels="_listenChart.labels"
              width="100%"
              :horizontal="true"
              height="300"
            />
          </div>
        </div>
      </v-card>
    </section>
    <section style="display: flex; padding-top:10px;">
      <v-card
        class="d-flex flex-column ma-3"
        style="width: 100%; overflow: hidden"
      >
        <v-card-title>Watch</v-card-title>
        <div
          style="width: 100%; min-height: 100%; display:flex; padding-left:10px;"
        >
          <div
            class="d-flex flex-column"
            style="min-width: 15%; max-width: 15%; height:100%; margin-top:50px;"
          >
            <img
              contain
              src="../../assets/pga.png"
              style="max-width: 85px; max-height: 90px; padding-bottom:30px;"
            />
            <img
              contain
              src="../../assets/shark.png"
              style="max-width: 85px; max-height: 90px; padding-bottom:30px;"
            />
            <img
              contain
              src="../../assets/atmosphere.png"
              style="max-width: 85px; max-height: 90px; padding-bottom:30px;"
            />
            <img
              contain
              src="../../assets/yahoosports.png"
              style="max-width: 85px; max-height: 90px; padding-bottom:30px;"
            />
            <img
              contain
              src="../../assets/yahoonews.png"
              style="max-width: 85px; max-height: 90px; padding-bottom:30px;"
            />
          </div>
          <div style="min-width: 90%">
            <chart
              type="bar-chart"
              :flat="true"
              :data="_watchChart.data"
              :labels="_watchChart.labels"
              width="100%"
              :horizontal="true"
              height="500"
            />
          </div>
        </div>
      </v-card>
    </section>
  </section>
</template>

<script>
import moment from 'moment';
import { MobileView } from '@/mixins';
import Chart from '@/components/charts/Chart';

export default {
  components: {
    Chart,
  },
  mixins: [MobileView],
  props: [
    '_dynamicYardageChart',
    '_roundsPlayed',
    '_scorecardChart',
    '_foodAndBeverageChart',
    '_listenChart',
    '_watchChart',
  ],
  computed: {
    graphClass() {
      if (this.showMobileView) {
        return 'd-flex flex-column';
      }
      return 'd-flex flex-row';
    },
    graphHeight() {
      if (this.showMobileView) {
        return '33%';
      }
      return '100%';
    },
    date() {
      return moment().format('YYYY-MM-DD');
    },
  },
  methods: {
    graphWidth(width) {
      if (width && !this.showMobileView) {
        return width;
      }
      if (this.showMobileView) {
        return '100%';
      }
      return '47%';
    },
  },
};
</script>

<style></style>
